import React, { useContext, useEffect, useState } from 'react'
import styles from './AuditLogs.module.css'
import { globalContext } from '../../Provider/AppProvider';
import { GET_NOTIFICATIONS } from '../../components/shared-components/notification/api/NotificationQuery';
import { useLazyQuery } from '@apollo/client';
import { getFormattedDate } from '../../helper';
import AuditLogitixLogs from '../../components/shared-components/auditLogs/AuditLogitixLogs';
import ErrorDashboard from '../ErrorDashboard/ErrorDashboard';

const AuditLogs = () => {

  const {globalState,handleGlobalState} = useContext<any>(globalContext)
  localStorage.removeItem('ticketsTabIndex');
  localStorage.removeItem('settingsTabIndex');
  const [activeTab, setActiveTab] = useState(0);

  const [tempRowsPerPage, setTempRowsPerPage] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(parseInt(tempRowsPerPage ? tempRowsPerPage : '') || 10);
  const [currentPage, setCurrentPage] = useState(1);
  const [checking,setChecking]=useState<boolean>(false);
  

  const [auditLogsList,setAuditLogsList] = useState<any>([{}]);

  const [columnTypes, setColumnTypes] = useState('');
 


  const [sortType, setSortType] = useState('desc');
  const [selected, setSelected] = useState<number[]>([]);
  const date = getFormattedDate(new Date());

  const [getNotification] = useLazyQuery(GET_NOTIFICATIONS,{
    fetchPolicy:"no-cache",
    onCompleted:(data)=>{
      const tempState = {...globalState}
      tempState.notificationCount.recent = data?.currentCount?.aggregate?.count
      tempState.notificationCount.past = data?.pastCount?.aggregate?.count
      handleGlobalState(tempState)
    }
  })

  useEffect(()=>{
    const tempValue = {...globalState};
    if(globalState.globalSearch.affiliateUsersClicked){
      tempValue.globalSearch.searchtext = "";
      tempValue.globalSearch.affiliateUsersClicked = false;
    }
    if(globalState.notification.notificationClicked){
      tempValue.notification.notificationClicked = false;
      tempValue.notification.tp_id_array=null;
      tempValue.globalSearch.searchtext = "";
      tempValue.notification.text = "";
      tempValue.notification.ticketId =null;
      tempValue.notification.tpId = null;
    }else if(globalState.error.errorClicked){
      tempValue.error.errorClicked = false;
      tempValue.globalSearch.searchtext = "";
      tempValue.error.text = "";
      tempValue.error.approximateTpArray = null
      tempValue.error.ticketPlacementId = null
      tempValue.error.status =""
    }
    handleGlobalState(tempValue);
    getNotification({
      variables:{
        todayDate: date,
        userId: globalState?.profile?.id
      }
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  /* For get the ManageTicket table headers */
  const GenerateAuditLogsHeadCells = ()=>{
    const id =  ["event_name","league_name","api_type","action","status","ticket_placements","venue","old_listing_price","updated_listing_price","user_name"];
    const labels =["Event Name","League Name","API Type","Action","Status","Ticket Placements,Section,Row, Seat", "Venue","Old Listing Price","Updated Listing Price","User Name"];
    const headCells = id.map((id, index) => ({
        id,
        label: labels[index],
      }));
      return headCells;
}

const handleChangeRowsPerPage = (event: any) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setTempRowsPerPage(event.target.value);
  setSelected([]);
  setCurrentPage(1);
};

const handlePageChange = (_event: React.ChangeEvent, newPage: number) => {
  setCurrentPage(newPage);
  setSelected([]);
  setChecking(false)
};

const handleTabSelect = (tabIndex: number) => {
  setActiveTab(tabIndex);
  setSelected([]);
  setCurrentPage(1);
  setChecking(false);
};

  return (
      <div className={styles.pageContainer}>
        <div className={styles.tabContainer}>
          <button
            type="button"
            className={`${styles.tab} ${activeTab === 0 ? styles.activeTab : ""}`}
            onClick={() => handleTabSelect(0)}
          >
            Mail Parser Logs
          </button>
          <button
            type="button"
            className={`${styles.tab} ${activeTab === 1 ? styles.activeTab : ""}`}
            onClick={() => handleTabSelect(1)}
          >
            Super User - Audit Logs
          </button>
        </div>
        {activeTab === 0 ? (
          <div className={styles.tabPanel}>
            <ErrorDashboard />
          </div>
        ) : (
          <div className={styles.tabPanel}>
            <AuditLogitixLogs
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              checking={checking}
              setChecking={setChecking}
              auditLogsList={auditLogsList}
              setAuditLogsList={setAuditLogsList}
              columnTypes={columnTypes}
              setColumnTypes={setColumnTypes}
              sortType={sortType}
              setSortType={setSortType}
              selected={selected}
              setSelected={setSelected}
              GenerateAuditLogsHeadCells={GenerateAuditLogsHeadCells}
              handleChangeRowsPerPage={handleChangeRowsPerPage}
              handlePageChange={handlePageChange}
            />
          </div>
        )}
      </div>
  );
}

export default AuditLogs;